import * as React from 'react'
import PropTypes from 'prop-types'

export const Iframe = React.forwardRef((props, ref) => {
  return (
    <iframe
      style={{ height: '100%', width: '100%' }}
      src={props.launchUrl}
      allow={props.allow}
      frameBorder="0"
      title={props.title}
      id="game"
      ref={ref}
    />
  )
})

Iframe.displayName = 'Iframe'

Iframe.defaultProps = {
  allow: 'fullscreen *',
  title: 'game',
}

Iframe.propTypes = {
  launchUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  allow: PropTypes.string,
}
